module.exports = __webpack_public_path__ + "img/audio_classify13.3f845197.png";